import React from "react";
import { FaWhatsapp } from "react-icons/fa"; // WhatsApp official icon

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/919876543210" // replace with your WhatsApp number
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg transition transform hover:scale-110 z-50"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={28} />
    </a>
  );
};

export default WhatsAppButton;
